import { render, staticRenderFns } from "./SWA.vue?vue&type=template&id=6f1ac546"
import script from "./SWA.vue?vue&type=script&lang=js"
export * from "./SWA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f1ac546')) {
      api.createRecord('6f1ac546', component.options)
    } else {
      api.reload('6f1ac546', component.options)
    }
    module.hot.accept("./SWA.vue?vue&type=template&id=6f1ac546", function () {
      api.rerender('6f1ac546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/SWA.vue"
export default component.exports